import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byUserProfileIdAndSurveyId: {}
});

export default (state = getInitialState(), action) => {
    let newByUserProfileIdAndSurveyId;
    switch (action.type) {
        case ACTIONS.GET_ALL_USER_SURVEY_DATA: {
            newByUserProfileIdAndSurveyId = action.payload.usersurveydata.reduce((prev, userSurveyData) => {
                prev[`${userSurveyData.userProfileId}|${userSurveyData.surveyId}`] = userSurveyData;
                return prev;
            }, {});

            return {
                ...state,
                byUserProfileIdAndSurveyId: newByUserProfileIdAndSurveyId
            };
        }

        case ACTIONS.GET_USER_SURVEY_DATA: {
            const { usersurveydata } = action.payload;
            newByUserProfileIdAndSurveyId = Object.assign({}, state.byId, {
                [`${usersurveydata.userProfileId}|${usersurveydata.surveyId}`]: usersurveydata
            });

            return Object.assign({}, state, {
                byUserProfileIdAndSurveyId: newByUserProfileIdAndSurveyId
            });
        }
        case ACTIONS.POST_USER_SURVEY_DATA_SUCCESS: {
            const { usersurveydata } = action.payload;
            newByUserProfileIdAndSurveyId = Object.assign({}, state.byId, {
                [`${usersurveydata.userProfileId}|${usersurveydata.surveyId}`]: usersurveydata
            });

            return Object.assign({}, state, {
                byUserProfileIdAndSurveyId: newByUserProfileIdAndSurveyId
            });
        }

        default:
            return state;
    }
};
